// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__pN8dC","body":"styles_body__8khOm","icon":"styles_icon__BB7TC","titleWrap":"styles_titleWrap__OK+6Z","bodyItem":"styles_bodyItem__iQB04"};